module.exports = __webpack_public_path__ + "static/media/state-planet-15.b770634b.png";